import Bar from "./Bar";
import Card from "../Card";
import StatGrid from "../dashboard/StatGrid";

// Mirrors the dashboard shells rather than showing a stack of generic lines.
// Composable because the three dashboards differ:
//   Company  tileRows={[4, 4]}  charts
//   Admin    tileRows={[5, 4]}  charts
//   Agent    tileRows={[3]}     tableCards={2}

// MobileCard: h-[120px] bg-gray-100, 27% icon column, 73% value + label.
const Tile = () => (
  <div className="flex h-[120px] w-full items-center bg-gray-100">
    <div className="flex h-full w-[27%] items-center justify-center">
      <Bar w={40} h={62} r={6} />
    </div>
    <div className="flex h-full w-[73%] flex-col items-center justify-center gap-2">
      <Bar w={68} h={22} />
      <Bar w={126} h={12} />
    </div>
  </div>
);

// TrendChart: a container-width, 300px-tall plot with a y-axis and month
// ticks, and a caption beside it from sm up (below it on phones).
const ChartBlock = () => (
  <div className="flex w-full flex-col gap-4 sm:flex-row sm:items-center">
    <div className="flex min-w-0 flex-1" style={{ height: 300 }}>
      <div className="flex w-9 flex-col justify-between py-2">
        {Array.from({ length: 5 }, (_, i) => (
          <Bar key={i} w={22} h={10} />
        ))}
      </div>

      <div className="flex flex-1 flex-col">
        <Bar w="100%" h={250} r={6} />
        <div className="mt-2 flex justify-between">
          {Array.from({ length: 12 }, (_, i) => (
            <Bar key={i} w={18} h={10} />
          ))}
        </div>
      </div>
    </div>

    <div className="flex flex-col gap-2">
      <Bar w={96} h={20} />
      <Bar w={118} h={20} />
      <Bar w={104} h={20} />
    </div>
  </div>
);

// "Recent Listings" / "Recent Buyers": heading + View All, then a small table.
const TableCard = ({ rows = 5 }) => (
  <Card>
    <div className="p-6">
      <div className="mb-6 flex items-center justify-between border-b-2 border-primary pb-2">
        <Bar w={190} h={24} />
        <Bar w={78} h={16} />
      </div>
      <div className="flex flex-col gap-3">
        {Array.from({ length: rows }, (_, i) => (
          <div key={i} className="flex items-center gap-4">
            <Bar w="28%" h={12} />
            <Bar w="18%" h={12} />
            <Bar w="22%" h={12} />
            <Bar w="14%" h={12} />
          </div>
        ))}
      </div>
    </div>
  </Card>
);

const DashboardSkeleton = ({ tileRows = [4, 4], charts = false, tableCards = 0 }) => (
  <div className="flex flex-col gap-6">
    <Card>
      <div className="p-4 sm:p-6">
        {/* "Overview" + Export CSV */}
        <div className="mb-6 flex w-full flex-wrap items-center justify-between gap-3 border-b-2 border-primary pb-2">
          <Bar w={168} h={30} />
          <Bar w={132} h={36} r={6} />
        </div>

        <div className="flex flex-col gap-4">
          {tileRows.map((count, r) => (
            <StatGrid key={r} cols={count}>
              {Array.from({ length: count }, (_, i) => (
                <Tile key={i} />
              ))}
            </StatGrid>
          ))}
        </div>

        {charts && (
          <div className="mt-4 grid grid-cols-1 gap-6 xl:grid-cols-2">
            <ChartBlock />
            <ChartBlock />
          </div>
        )}
      </div>
    </Card>

    {Array.from({ length: tableCards }, (_, i) => (
      <TableCard key={i} />
    ))}
  </div>
);

export default DashboardSkeleton;
